/**
 * Filters out an object by its values.
 * By default, removes any null values.
 *
 * @param obj
 * @param check
 */
const filterValues = (obj, check = x => x !== null) => {
  const ret = {};
  Object.keys(obj).forEach(i => {
    const val = obj[i];
    if (check(val)) {
      ret[i] = val;
    }
  });

  return ret;
};

/**
 * Replaces null or undefined properties of an object with values from a "defaults" object. This is useful
 * when dealing with forms, to ensure inputs always have a value and are thus "controlled" inputs.
 *
 * @param values the data object
 * @param defaults the values to populate for null or undefined keys
 * @returns {*} merged data
 */
function mergeDefaults(values, defaults) {
  if (values === null || values === undefined) {
    return defaults;
  }

  if (typeof values !== "object" || typeof defaults !== "object" || Array.isArray(values) || Array.isArray(defaults)) {
    return values;
  }

  const result = {};

  for (const key in defaults) {
    result[key] = mergeDefaults(values[key], defaults[key]);
  }

  for (const key in values) {
    if (!(key in defaults)) {
      result[key] = values[key];
    }
  }

  return result;
}

/**
 * Returns a copy of an object with a prefix added to the keys of the original.
 *
 * @param obj the object to prefix
 * @param prefix the prefix to prepend to the keys
 * @returns {{}} object with keys prefixed
 */
const prefixKeys = (obj, prefix) => {
  const newObj = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      newObj[prefix + key] = obj[key];
    }
  }

  return newObj;
};

export {
  filterValues,
  mergeDefaults,
  prefixKeys
};
